/* eslint-disable no-undef */
export const URL_API = process.env.REACT_APP_URL_API;
export const NODE_ENV = process.env.NODE_ENV;
